module.exports = __webpack_public_path__ + "static/img/专利1.6454589f.png";